import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { spacing } = theme.busbud;

  return {
    operatorRatingsCardHeader: {
      marginRight: spacing(1)
    },
    operatorRatingsCardHeaderLogo: {
      minWidth: 0 // Forces the block to shrink when the element is full
    },
    ratingLabelContainerOverride: {
      flexDirection: "column",
      alignItems: "end"
    },
    ratingCategories: {
      gap: spacing(1),
      "& span": {
        textTransform: "capitalize"
      }
    },
    ratingCategoryChipEndIcon: {
      marginLeft: spacing(1.5),
      marginRight: spacing(-0.375)
    },
    loader: {
      display: "flex",
      justifyContent: "center"
    }
  };
});
